export default __webpack_public_path__ + "static/background-f23f4bce1ad0bfdcdc26fc0fcdcb3180.png";